import { createFileRoute } from '@tanstack/react-router';

type CustomerSearchParams = {
  tab?: string;
  q?: string;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
  hasOrders?: string;
  emailVerified?: string;
};

export const Route = createFileRoute('/customers/')({
  validateSearch: (search: Record<string, unknown>): CustomerSearchParams => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    dateFrom: typeof search.dateFrom === 'string' ? search.dateFrom : undefined,
    dateTo: typeof search.dateTo === 'string' ? search.dateTo : undefined,
    hasOrders: typeof search.hasOrders === 'string' ? search.hasOrders : undefined,
    emailVerified: typeof search.emailVerified === 'string' ? search.emailVerified : undefined,
  }),
});
